import React, { useState, useEffect } from 'react'
import { Navbar } from '../../Components/Navbar'
import { Submit } from '../../Components/Button'
import swal from "sweetalert";
import axios from "axios";
import { motion } from "framer-motion";
import { comanyUpdate, getcomanyUpdate } from '../../WorkSpace/Components/ApiServices/apiHandler'
import { getProfile, logoutUser } from '../../services/api/apiHandler';
import { logout } from '../../authentication/authUtilities';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import Sidebar from '../../myfin_v2/elements/Sidebar';
import companycss from '../../myfin_v2/css/company.module.css';
import commoncss from '../../myfin_v2/css/common.module.css';
import userProfileCss from '../../myfin_v2/css/userprofile.module.css';
import defaultUserImg from '../../assets/Image/defaultUserImage.png';
import { ReactComponent as EditIcon } from '../../assets/edit.svg';
import UpdateProfileModal from '../../myfin_v2/components/userprofile/UpdateProfileModal';

const ProfileChange = () => {
	const user = JSON.parse(localStorage.getItem('user'));
	const history = useHistory();
	const [refreshKey, setRefreshKey] = useState(0);
	const [setprofile, setProfileData] = useState({
		id: "",
		email: "",
		oldemail: "",
		password: "",
		OldPassword: "",
		name: "",
		profile_img: ""
	});
	const [setdomain, setDomainData] = useState({
		domain: "",
	});

	const [displayModal, setDisplayModal] = useState(false);
	const [updateProfileModal, setUpdateProfileModal] = useState(false);

	const handleProfileChange = (id, e) => {
		const { name, value } = e.target;
		setProfileData({ ...setprofile, [name]: value })
	}

	// const handledomainChange = (id, e) => {
	// 	const { name, value } = e.target;
	// 	setDomainData({ ...setdomain, [name]: value })
	// }

	const handleClose = () => {
        setDisplayModal(false);
    };

	useEffect(() => {
		getProfile().then(response => {
			if (response.status === 200) {
				console.log("test profile api", response.data.user.data)
				setProfileData({
					id: response.data.user.data._id,
					email: response.data.user.data.email,
					oldemail: response.data.user.data.email,
					name: response.data.user.data.name,
					password: "",
					oldPassword: "",
					profile_img: response.data.user.data.profile_image || ""
				});
				const UserId = response.data.user.data.isAdmin === "Yes"
					? response.data.user.data._id
					: response.data.user.data.parent_id;
				if (UserId) { getUpdateDomain(UserId); }
				swal("Success", response.data.message, "success")
			}
		}).catch((error) => {
			console.log(error.response, "error");
			// swal("", error.response.data.error, "error");
		});
	}, [refreshKey]);

	const getUpdateDomain = async (id) => {
		try {
			const domaindata = await getcomanyUpdate(id)
			console.log(domaindata, "domaindata===")
			if (domaindata.status === 200) {
				setDomainData({
					domain: domaindata.data.data.domain
				})

			}

		} catch (error) {
			console.log(error);
		}
	}


	// const handleDomainUpdate = async (id, e) => {
	// 	console.log(e);
	// 	e.preventDefault();
	// 	try {

	// 		const data = {
	// 			domain: setdomain.domain,
	// 			user_id: id
	// 		}

	// 		const companydata = await comanyUpdate(data)

	// 		if (companydata.status === 200) {
	// 			swal("Successfully Update")
	// 			// data.domain("")
	// 		}

	// 	} catch (error) {
	// 		console.log(error)
	// 	}


	// }

	// const handleUpdate = (id, e) => {
	// 	const auth = localStorage.getItem("auth_token");
	// 	let headers = {
	// 		"x-auth-token": auth,
	// 		"Content-Type": "application/json",
	// 	};
	// 	axios
	// 		.post(`api/v1/auth/update-profile`, setprofile, { headers })
	// 		.then((response) => {
	// 			if (response.status === 200) {
	// 				swal("Success", "Password Updated Successfully", "success").then(() => {
	// 					logoutUser().then(response => {
	// 						toast.success("Logout Successfully");
	// 						logout();
	// 						history.push("/");
	// 					}).catch(error => {
	// 						toast.error(error.response?.data?.error || "Logout Failed!");
	// 					})
	// 				});

	// 			}
	// 		})
	// 		.catch((error) => {
	// 			swal("Error", error.response.data.message, "error");
	// 		});
	// }


	return (
		<>
			{/* <div className="pb-2">
				<div>
				<Navbar />
				</div>
      		</div> */}
			<div className={userProfileCss.dFlex} key={refreshKey}>
				<Sidebar />
				<motion.div
					initial={{ x: 200, opacity: 0 }}
					animate={{ x: 0, opacity: 1 }}
					exit={{ x: 200, opacity: 0 }}
					transition={{ duration: 1, ease: "easeInOut" }}
					className="w-100"
				>
					<div className={userProfileCss.profileLayout}>
						<div className={userProfileCss.profileContainer}>
							<div className={userProfileCss.profileDataSection}>
								<div className={userProfileCss.ProfileHeader}>
									<div className={userProfileCss.userProfileSection}>
										<div>
											<img className={userProfileCss.userImage} 
												src={setprofile.profile_img.url || defaultUserImg}
												alt='user_img'
												onError={(e) => {
													e.target.onerror = null;
													e.target.src = defaultUserImg;
												}} 
											/>
										</div>
										<div className={commoncss.dFlexClm}>
											<span className={userProfileCss.userName}>
												{setprofile.name}
											</span>
											<span className={userProfileCss.userEmail}>
												{setprofile.email}
											</span>
										</div>
									</div>
									<div>
										<button className={userProfileCss.outlinedBtns} onClick={() => { setUpdateProfileModal(true); setDisplayModal(true); }}> <EditIcon /> Edit Profile</button>
									</div>
								</div>

								<hr className={userProfileCss.marginTop40} />

								<div className={userProfileCss.profileDetailsContainer} >
									<div className={commoncss.dFlex}>
										<div className={commoncss.dFlexClm}>
											<span className={userProfileCss.profileDetailsText}>
												Profile Details
											</span>
											<span className={userProfileCss.profileDetailsSubText}>
												Basic information about the user
											</span>
										</div>
									</div>
									<div className={commoncss.dFlexClm} style={{ gap: "10px" }}>
										<div className={commoncss.dFlexClm}>
											<div className="d-flex" style={{ gap: "30px" }}>
												<span
													className={userProfileCss.profileDataSubText}
													style={{ width: "150px" }}
												>
													Username
												</span>
												<span className={userProfileCss.profileDataText}>
													{setprofile.name}
												</span>
											</div>
										</div>
										<div className={commoncss.dFlexClm}>
											<div className="d-flex" style={{ gap: "30px" }}>
												<span
													className={userProfileCss.profileDataSubText}
													style={{ width: "150px" }}
												>
													Email address
												</span>
												<span className={userProfileCss.profileDataText}>
													{setprofile.email}
												</span>
											</div>
										</div>

										<div className={commoncss.dFlexClm}>
											<div className="d-flex" style={{ gap: "30px" }}>
												<span
													className={userProfileCss.profileDataSubText}
													style={{ width: "150px" }}
												>
													Password
												</span>
												<span className={userProfileCss.profileDataText}>
													{Array.from({ length: 10 }).map(() => (
														<span className={userProfileCss.customPoint}></span>
													))}
												</span>
											</div>
										</div>
									</div>
								</div>

								<hr className={userProfileCss.marginTop40} />

							</div>
						</div>
					</div>
					{updateProfileModal && displayModal && (
						<UpdateProfileModal
							handleClose={handleClose}
							setUpdateProfileModal={setUpdateProfileModal}
							setprofile = {setprofile}
							handleProfileChange={handleProfileChange}
							setRefreshKey={setRefreshKey}
						/>
					)}
				</motion.div>
			</div>
			{/* <div className="dahboardHeaderV2">
        <div className="row">
          <div className="col-md-12">
            <h5 className="dbwcardhead">Update Profile</h5>
          </div>
        </div>

        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-md-12">
            <label>Email</label>
            <div className='inputs in-1'>
              <input
                name='email'
                disabled
                onChange={(e) => handleProfileChange(setprofile.id, e)}
                value={setprofile.email}
              ></input>
            </div>
          </div>
          <div className="col-md-12">
            <label>Old Password</label>
            <div className='inputs in-1'>
              <input
                name='oldPassword'
                onChange={(e) => handleProfileChange(setprofile.id, e)}
                value={setprofile.oldPassword}
              ></input>
            </div>
          </div>
          <div className="col-md-12">
            <label>New Password</label>
            <div className='inputs in-1'>
              <input
                name='password'
                onChange={(e) => handleProfileChange(setprofile.id, e)}
                value={setprofile.password}
              ></input>
            </div>
          </div>
          <div className="col-md-12">
            <button className="rwp-btn" onClick={(e) => {
              handleUpdate(setprofile.id, e);
            }}>
              Update
            </button>
          </div>
        </div>
      </div>

      <div className="dahboardHeaderV2">
        <div className="row">
          <div className="col-md-12">
            <h5 className="dbwcardhead">Company Update</h5>
          </div>
        </div>

        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-md-12">
            <label>Domain</label>
            <div className='inputs in-1'>
              <input
                name='domain'
                disabled={user?.isAdmin==="No"}
                onChange={(e) => handledomainChange(setdomain, e)}
                value={setdomain.domain}
              ></input>
            </div>
          </div>
          <div className="col-md-12">
            <label>Bio</label>
            <div className='inputs in-1'>
              <input
              disabled
                // name='email'
                // onChange={(e) => handleProfileChange(setprofile.id, e)}
                // value={setprofile.email}
              ></input>
            </div>
          </div>
          <div className="col-md-12">
            <label>Logo</label>
            <div className='inputs in-1'>
              <input
              disabled
                // name='email'
                // onChange={(e) => handleProfileChange(setprofile.id, e)}
                // value={setprofile.email}
              ></input>
            </div>
          </div>
          <div className="col-md-12">
            <button className="rwp-btn" onClick={(e) => {
              handleDomainUpdate(setprofile.id, e);
            }}
            disabled={user?.isAdmin === "No"} 
            >
              Update
            </button>
          </div>
        </div>
      </div> */}
		</>

	)
}
export default ProfileChange